<template>
  <CDropdown inNav class="c-header-nav-items" placement="bottom-end" add-menu-classes="pt-0">
    <template #toggler>
      <CHeaderNavLink>
        <div class="c-avatar">
          <img :src="$store.state.fotoUsuario" class="c-avatar-img"/>
        </div>
      </CHeaderNavLink>
    </template>
    <CDropdownHeader tag="div" class="text-center" color="light">
      <strong>Cuenta del Docente</strong>
    </CDropdownHeader>
    <CDropdownItem to="/usuario/consultaperfil">
      <i class="fas fa-user-edit mr-2"></i> Datos del docente
    </CDropdownItem>
    <CDropdownItem>
      <i class="fas fa-unlock-alt mr-2"></i> Contraseña
    </CDropdownItem>
    <CDropdownDivider/>
    <CDropdownItem :href="$store.state.rutaIngreso">
      <i class="fas fa-sign-out-alt mr-2"></i> Cerrar sesión
    </CDropdownItem>
  </CDropdown>
</template>

<script>
export default {
  name: 'TheHeaderDropdownAccnt',
  data () {
    return { 
      itemsCount: 0
    }
  },
  methods: {
  },
  beforeMount() {
  }
}
</script>

<style scoped>
  .c-icon {
    margin-right: 0.3rem;
  }
</style>